<template>
  <el-tree :data="datalist" node-key="Id" default-expand-all :expand-on-click-node="false" @node-click="nodeClick">
    <div class="custom-tree-node show-hide" slot-scope="{ data }">
      <span>{{ data.Sort }}.{{ data.Name }}</span>
      <div style="display: none">
        <template v-if="data.Id">
          <el-link type="primary" @click="openForm(data)">修改</el-link>
          <el-link type="danger" @click="onDelete(data.Id)">删除</el-link>
        </template>
        <el-link v-else type="primary" icon="el-icon-plus" @click="openForm()">添加部门</el-link>
      </div>
    </div>
  </el-tree>
</template>

<script>
import form from './form.vue'
export default {
  data () {
    return {
      datalist: null
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    //获取数据列表
    loadData () {
      this.$apis.organize.dept.list().then(res => {
        this.datalist = [{ Name: '全部部门', children: res }]
      })
    },

    //点击行执行
    nodeClick (data) {
      this.$emit('nodeClick', data)
    },

    //编辑
    openForm (row) {
      this.$layer.iframe({
        title: "部门表单",
        content: {
          content: form,
          parent: this,
          data: {
            _detail: row
          }
        }
      })
    },

    //删除数据
    onDelete (id) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "删除部门", {
        center: true
      }).then(() => {
        this.$apis.organize.dept.delete({ id: id }).then(() => {
          this.loadData()
          this.$message({ message: "数据删除成功！", type: "success" })
        }).catch(e => {
          this.$message.console.error(e || "数据删除失败！")
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.el-tree-node__content) {
  height: 40px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.show-hide:hover :nth-child(2) {
  display: inline-block !important;
}
</style>